import React from 'react';
import PropTypes from 'prop-types';
import { renderFields } from '../../util/RenderUtil';

/** renders a field group well */
const FieldGroupWell = props => {
  const { title, info } = props; 
  return (
    <div className="field-group-well">
      {title && <div className="field-group-well-title">{title}</div>}
      {info && <div className="field-group-well-info">{info}</div>}
      {renderFields(props)}
    </div>
  );
};

FieldGroupWell.propTypes = {
  info: PropTypes.node,
  title: PropTypes.string
};

export default FieldGroupWell;
